var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Infrastructure"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshList(true, true)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "fal fa-search",
                      placeholder: "Search",
                      "single-line": "",
                      "hide-details": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "1000px" },
                      model: {
                        value: _vm.deletedSystemsDialog,
                        callback: function ($$v) {
                          _vm.deletedSystemsDialog = $$v
                        },
                        expression: "deletedSystemsDialog",
                      },
                    },
                    [
                      _vm.deletedSystemsDialog
                        ? _c("deleted-systems", {
                            on: {
                              systemUnDeleted: _vm.refreshList,
                              systemsUnDeleted: _vm.refreshList,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.deletedSystemsDialog = true
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "20",
                                        color: "grey lighten-1",
                                      },
                                    },
                                    [_vm._v("far fa-recycle")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Manage Recycle Bin")])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    options: _vm.pagination,
                    headers: _vm.headers,
                    items: _vm.systems,
                    search: _vm.search,
                    loading: _vm.loading,
                    expanded: _vm.expandedItems,
                  },
                  on: {
                    "update:options": function ($event) {
                      _vm.pagination = $event
                    },
                    "update:expanded": function ($event) {
                      _vm.expandedItems = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.id",
                      fn: function ({ item }) {
                        return [
                          _vm.isProfessional || _vm.isSU
                            ? _c("td", [_vm._v(_vm._s(item.id))])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.type.name",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c("v-avatar", { attrs: { size: "20" } }, [
                                _c("img", { attrs: { src: item.logo } }),
                              ]),
                              _vm._v(_vm._s(item.type.name) + "\n      "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.name",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "sysconfig",
                                      params: { id: item.id },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.name) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v("  \n\n        "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            item.isCloudSystem
                                              ? _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    { attrs: { small: "" } },
                                                    on
                                                  ),
                                                  [_vm._v("fal fa-cloud")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Cloud collection")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.host",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.formatHostLink(
                                    item.host,
                                    item.configs
                                  ),
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(item.host))]
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.createdDate",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(_vm._s(_vm.formatDate(item.createdDate))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.updatedDate",
                      fn: function ({ item }) {
                        return [
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(item.updatedDate))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.pollEnabled",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            [
                              _c("v-switch", {
                                attrs: {
                                  inset: "",
                                  readonly: "",
                                  "hide-details": "",
                                },
                                on: {
                                  "!click": function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.toggleEnabled(item)
                                  },
                                },
                                model: {
                                  value: item.pollEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(item, "pollEnabled", $$v)
                                  },
                                  expression: "item.pollEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            { staticClass: "actions" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                    "padding-right": "2px",
                                                  },
                                                  attrs: {
                                                    text: "",
                                                    icon: "",
                                                    to: {
                                                      name: "sysconfig",
                                                      params: { id: item.id },
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-pencil")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Edit")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticStyle: {
                                                    height: "0px",
                                                    width: "0px",
                                                    "padding-right": "2px",
                                                  },
                                                  attrs: { text: "", icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteSystem(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-trash")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_vm._v(" "), _c("span", [_vm._v("Delete")])]
                              ),
                              _vm._v(" "),
                              !_vm.noValidation(item)
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "0px",
                                                        width: "0px",
                                                        "padding-right": "2px",
                                                      },
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.validateSystem(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "18px",
                                                        },
                                                        attrs: {
                                                          color:
                                                            "grey lighten-1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "fas fa-check-circle"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Validate")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.noInfo(item)
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                item.pollEnabled && _vm.isSU
                                                  ? _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticStyle: {
                                                            height: "0px",
                                                            width: "0px",
                                                          },
                                                          attrs: {
                                                            text: "",
                                                            icon: "",
                                                          },
                                                          on: {
                                                            click: () =>
                                                              _vm.expandItem(
                                                                item
                                                              ),
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "18px",
                                                            },
                                                            attrs: {
                                                              color:
                                                                _vm.getInfoIconColor(
                                                                  item.id
                                                                ),
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n              fas fa-info-circle"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getAlarmText(item.id) ||
                                              "Metrics, Logs, Realtime Data Feed"
                                          ) + " "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "expanded-item",
                      fn: function ({ headers, item }) {
                        return [
                          _c(
                            "td",
                            { attrs: { colspan: "11" } },
                            [
                              _c("metrics-logs", {
                                attrs: {
                                  hideCollectorLogs: item.isCloudSystem,
                                  hideMetrics: item.isCloudSystem,
                                  metricsKeyLike: "",
                                  metricsSrcIdFilter: item.id,
                                  logFilter: "-" + item.id + "%5D",
                                  logSrcIdFilter: item.id,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        type: "warning",
                      },
                      slot: "no-results",
                    },
                    [
                      _vm._v(
                        '\n        Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n      '
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("new")
                        },
                      },
                    },
                    [_vm._v("New Infrastructure")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(
                    "\n        " + _vm._s(_vm.driverStatus) + "\n        "
                  ),
                  !_vm.collectorsNotFound
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            icon: "",
                            color: "grey lighten-1",
                            loading: _vm.loadingDrivers,
                          },
                          on: { click: _vm.refreshDrivers },
                        },
                        [_c("v-icon", [_vm._v("fas fa-sync")])],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "500" },
          model: {
            value: _vm.systemRemoteValidationDialog,
            callback: function ($$v) {
              _vm.systemRemoteValidationDialog = $$v
            },
            expression: "systemRemoteValidationDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.systemRemoteValidationStatus)),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _c("h3", [_vm._v(_vm._s(_vm.systemRemoteValidationMessage))]),
                _vm._v(" "),
                _vm.systemRemoteValidationMessages.length
                  ? _c(
                      "p",
                      [
                        _vm._v("Details:\n                                "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            nativeOn: {
                              click: function ($event) {
                                _vm.showErrDetails = !_vm.showErrDetails
                              },
                            },
                          },
                          [
                            _c("v-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.showErrDetails
                                    ? "fas fa-chevron-up"
                                    : "fas fa-chevron-down"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showErrDetails
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.systemRemoteValidationMessages,
                        function (msg, i) {
                          return _c("p", { key: i }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(msg) +
                                "\n                        "
                            ),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-4 was-orange",
                      attrs: { color: "primary", outlined: "", rounded: "" },
                      on: {
                        click: function ($event) {
                          _vm.systemRemoteValidationDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.waitDialog,
            callback: function ($$v) {
              _vm.waitDialog = $$v
            },
            expression: "waitDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n                    Please stand by\n                    "
                  ),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }